import React, { Component } from 'react';
// import { LayoutSplashScreen } from '../../../_metronic';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import * as auth from '../../store/ducks/auth.duck';

class Logout extends Component {
    componentDidMount () {
        this.props.logout();
    }

    render () {
        const { hasAuthToken } = this.props;

        return hasAuthToken ? <div>logout</div> : <Redirect to="/auth" />;
    }
}

export default connect(
    ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken) }),
    auth.actions
)(Logout);
